import React from 'react';
import { Button } from '../ui/button';
import { Star, MapPin } from 'lucide-react';
import { Logo } from '../Logo';
import { shopInfo } from '../../mock';

export const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-32 pb-20 bg-stone-700 overflow-hidden">
      {/* Subtle Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.03) 35px, rgba(255,255,255,.03) 70px)`
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          {/* Rating Badge */}
          <div className="inline-flex items-center space-x-2 bg-stone-600/50 backdrop-blur-sm px-4 py-2 rounded-full border border-stone-500">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`h-4 w-4 ${
                    i < Math.floor(shopInfo.rating)
                      ? 'fill-maroon-600 text-maroon-600'
                      : 'text-stone-600'
                  }`}
                />
              ))}
            </div>
            <span className="text-stone-300 text-sm font-medium">
              {shopInfo.rating} ({shopInfo.totalReviews} reviews)
            </span>
          </div>

          {/* Main Heading */}
          <div className="space-y-6">
            <Logo variant="full-light" className="h-32 sm:h-40 lg:h-48 w-auto mx-auto" />
            <p className="text-xl sm:text-2xl text-maroon-700 font-semibold">
              {shopInfo.tagline}
            </p>
            <p className="text-base sm:text-lg text-stone-400 max-w-2xl mx-auto">
              Experience traditional barbering at its finest. Serving Starkville since {shopInfo.ownedSince}.
            </p>
          </div>

          {/* Location */}
          <div className="flex items-center justify-center space-x-2 text-stone-300">
            <MapPin className="h-5 w-5 text-maroon-700" />
            <span>{shopInfo.address.city}, {shopInfo.address.state}</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-maroon-800 hover:bg-maroon-900 text-stone-100 px-8 py-6 text-lg font-semibold transition-all duration-200 hover:scale-105"
            >
              Join Waitlist
            </Button>
            <Button
              onClick={() => window.location.href = `tel:${shopInfo.phone}`}
              size="lg"
              variant="outline"
              className="border-2 border-stone-500 text-stone-100 hover:bg-stone-600 hover:border-maroon-700 px-8 py-6 text-lg font-semibold transition-all duration-200"
            >
              Call Now
            </Button>
          </div>

          {/* Features Pills */}
          <div className="flex flex-wrap items-center justify-center gap-3 pt-8">
            {shopInfo.amenities.map((amenity, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-stone-600/50 backdrop-blur-sm text-stone-300 rounded-full text-sm border border-stone-500"
              >
                {amenity}
              </span>
            ))}
            <span className="px-4 py-2 bg-stone-600/50 backdrop-blur-sm text-stone-300 rounded-full text-sm border border-stone-500">
              Walk-ins Welcome
            </span>
            <span className="px-4 py-2 bg-stone-600/50 backdrop-blur-sm text-stone-300 rounded-full text-sm border border-stone-500">
              MSU Student Friendly
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
